/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function CarModelDtoFromJSON(json) {
    return CarModelDtoFromJSONTyped(json, false);
}
export function CarModelDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'carModelId': !exists(json, 'carModelId') ? undefined : json['carModelId'],
        'modelName': !exists(json, 'modelName') ? undefined : json['modelName'],
    };
}
export function CarModelDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'carModelId': value.carModelId,
        'modelName': value.modelName,
    };
}
